import { GET_CONFIGURATION,ADD_WORKFLOW_ROUTE,GET_WORKROUTE,GET_CONFIGURATION_REQ } from "../types";

const INITIAL_STATE = {
  allConfig: [],
  addWorkflowRoute : [],
  getworkflowroute:[],
};

const configReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_CONFIGURATION_REQ:
      return {
        ...state,
      };
    case GET_CONFIGURATION:
      return {
        ...state,
        allConfig: payload.data,
       
      };
      case GET_WORKROUTE:
      return {
        ...state,
        getworkflowroute: payload.data,
     
      };
    case ADD_WORKFLOW_ROUTE:
        return {
          ...state,
          addWorkflowRoute: payload.data,
        };
    default:
      return state;
  }
};

export default configReducer;
